import { MediaSVGImage as  MediaSVGImage_t } from './MediaSVGImage'
import { MediaAPIImage as MediaAPIImage_t } from './MediaApiImage'
import { MediaImage as MediaImage_t } from './MediaImage'
import { MediaVideo as MediaVideo_t } from './MediaVideo'
import { MediaVideoFile as MediaVideoFile_t } from './MediaVideoFile'
import { MediaCroppedImage as MediaCroppedImage_t } from './types'
import { DrupalMedia as DrupalMedia_t } from './Media'

/**
 * Workaround for: https://github.com/babel/babel/issues/8361
 */
export type MediaSVGImage = MediaSVGImage_t
export type MediaAPIImage = MediaAPIImage_t
export type MediaImage = MediaImage_t
export type MediaVideo = MediaVideo_t
export type MediaVideoFile = MediaVideoFile_t
export type MediaCroppedImage = MediaCroppedImage_t
export type DrupalMedia = DrupalMedia_t

import Media from './Media'

export default Media
